<template>
	<div class="c-resources">
		<h2 v-if="resources.length > 0" class="t-text-style-gamma t-margin-bottom-s">Dokumentation och hjälpmedel</h2>
		<template v-for="resource in resources">
			<resource-item 
				:process-id="processId" 
				:process-type="processType"
				:process-step-id="processStepId" 
				:resource-id="resource.id"
				:sortIndex="getSortIndexForResource(resources, resource)"
				:sortIndexes="getSortIndexes(resources)"
				v-bind="resource" 
				@editResource="editResource"
				@deleteResource="deleteResource"
				@sortResources="sortResources">
			</resource-item>
		</template>
		<can i="manage" :a="processType">
			<button v-if="!showCreate" class="c-button c-button--secondary t-margin-top-s" @click.prevent="toggleShowCreate">Lägg till dokumentation</button>
			<resource-item 
				v-if="showCreate" 
				mode="create"
				:process-step-id="processStepId" 
				@createResource="createResource" 
				@toggleShowCreate="toggleShowCreate">
			</resource-item>
		</can>
	</div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import ResourceItem from './../resource-item/ResourceItem.vue';
export default {
    name: 'Resources',
	components: {ResourceItem},
    props: {
		processId: {
            type: String,
            default: '0',
        },
        processStepId: {
            type: String,
            default: '0',
        },
        processType: {
            type: String,
            default: '',
        },
		resources: {
			type: Array,
			default: () => [],
		},
		showCreate: {
			type: Boolean,
			default: false,
		},
    },
	methods: {
		getSortIndexes(resources) {
			const result = resources.length > 1 && resources.map(resource => resource.sortIndex).some(y => y !== 0) 
				? resources.map(resource => resource.sortIndex).sort(function(a, b){return a - b}) 
				: resources.map((r, i) => i);		
			return result;
		},
		getSortIndexForResource(resources, resource){
			const index = resources.length > 1 && resources.map(r => r.sortIndex).some(y => y !== 0)
				? resource.sortIndex
				: resources.indexOf(resource);
			return index;
		},
		sortResources({ id, sortIndex }){
			this.$emit('sortResources', { id, sortIndex });
        },
		toggleShowCreate() {
			this.$emit('setShowCreate', !this.showCreate);
		},
		createResource(resource) {
			this.$emit('createResource', resource);
		},
		deleteResource(resourceId) {
			this.$emit('deleteResource', resourceId);
		},
		editResource({resourceId, description, responsible, archive, archivePeriod}) {
			this.$emit('editResource', {resourceId, description, responsible, archive, archivePeriod});
		},
	}
}
</script>
